export const setApiKey = data => {
    return {
        type: "SET_API_KEY",
        payload: data,
    }
}

export function callStart(number) {
    return {
        type: "SOFTPHONE_CALL_START",
        number: number,
    }
}

export function callFinish(number) {
    return {
        type: "SOFTPHONE_CALL_FINISH",
    }
}

export function setNumber(number) {
    return {
        type: "SOFTPHONE_SET_NUMBER",
        number: number,
    }
}

export const setICEServers = servers => {
    return {
        type: "SOFTPHONE_ICE_SERVERS",
        data: servers,
    }
}

export const setSIPServers = servers => {
    return {
        type: "SOFTPHONE_SIP_SERVERS",
        data: servers,
    }
}

export const setSIPCredentials = credentials => {
    return {
        type: "SOFTPHONE_SIP_CREDENTIALS",
        data: credentials,
    }
}

export const setSoftphoneRegistered = () => {
    return {
        type: "SOFTPHONE_REGISTERED",
        payload: true,
    }
}

export const setSoftphoneAuth = () => {
    return {
        type: "SOFTPHONE_AUTH",
        payload: true,
    }
}

export const setSoftphoneError = data => {
    return {
        type: "SOFTPHONE_ERROR",
        error: data,
    }
}

export const setShowSoftphone = () => {
    return {
        type: "SHOW_SOFTPHONE",
        show: true,
    }
}

export const setHideSoftphone = () => {
    return {
        type: "HIDE_SOFTPHONE",
        show: false,
    }
}

export const setDialIn = data => {
    return {
        type: "SET_DIAL_IN",
        payload: data,
    }
}

export const setHangup = data => {
    return {
        type: "SET_HANGUP",
        payload: data,
    }
}

export const setDestroy = data => {
    return {
        type: "SET_DESTROY",
        payload: data,
    }
}

export const setPostbackURL = data => {
    return {
        type: "SET_POSTBACK_URL",
        payload: data,
    }
}

export const setDialParams = data => {
    return {
        type: "SET_DIAL_PARAMS",
        data,
    }
}
